import React from 'react';
export default class HeaderComponent extends React.Component {
    render () {
        return (
            <div id="header">
                <a href="/"><h3>clacking.club</h3></a>
            </div>
        );
    }
}